<template>
  <div id="openFlash">
    <div class="warnImg">
      <img :src="flashWarn" alt="">
    </div>
    <div class="tips">
      <p>浏览器没有启动或没有安装Flash Player，因此无法正常播放~~ </p>
      <p>
        <span>您可以</span>
        <a href="https://get2.adobe.com/cn/flashplayer/">立即启用或安装Flash Player播放器</a>
      </p>
    </div>
  </div>
</template>

<script>
  import FlashWarn from "@/assets/images/flashWarning.png";
  export default {
    name: "flash-tips",
    data() {
      return {
        flashWarn: FlashWarn,
      };
    },
  }
</script>

<style lang="stylus" scoped>
  @import "~@/assets/css/variable";
  #openFlash {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: $font_size_big;
    .warnImg {
      text-align: center;
      img {
        width: 100px;
      }
    }
    .tips {
      text-align: center;
      p {
        margin: 10px 0;
      }
      a {
        color: $color_suc;
      }
    }
  }
</style>